import compareVersions from 'compare-versions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAppConfigurationStore,
} from '../../mobx-store/storeInterfaces/appConfigurationInterface';
import classes from './addEditSettingsScreen.module.scss';

interface IProps extends WithSnackbarProps {
  appConfigurationStore: IAppConfigurationStore;
  history: any;
  match: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  processing: boolean;
}

@inject('appConfigurationStore')
@observer
class AddEditSettings extends Component<IProps, IState> {
  isNew = false;

  appConfigId = '';

  pageTitle = '';

  settingsFormTitle = '';

  submitButton: any;

  cancelButton: any;

  settingSchema: any;

  constructor(props: IProps) {
    super(props);
    if (this.props.match.params.id) {
      this.isNew = false;
      this.appConfigId = this.props.match.params.id;
      this.pageTitle = translate('editSettingsPageTitle', {
      });
    }
    this.initSettingSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.settingsFormTitle = translate('addSettingPageFormTitle', {
    });
  }

  initSettingSchema = () => {
    this.settingSchema = Yup.object().shape({
      key: Yup.string()
        .required('Required'),
      value: Yup.string()
        .required('Required'),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'key',
      label: translate('addStaticTextPageFormKey', {
      }),
      type: 'text',
      filedType: 'InputField',
      value: (this.isNew ? '' : this.props.appConfigurationStore.selectedConfiguration.key),
      disabled: (!this.isNew),
    },
    {
      name: 'value',
      label: translate('addStaticTextPageFormValue', {
      }),
      type: 'text',
      filedType: 'InputField',
      value: (this.isNew ? '' : this.props.appConfigurationStore.selectedConfiguration.value),
    },
  ];

  initState = () => {
    this.state = {
      loading: !this.isNew,
      formFields: this.getFormFields(),
      processing: false,
    };
  };

  handelCancel = (): void => {
    console.log('canceled');
    this.props.history.goBack();
  };

  getSettingFormValues = (values: any) => ({
    value: values.value,
  });

  handelSubmit = (values: any): void => {
    if ( values.key === 'MOBILE_APP_MINIMUM_VERSION' ){
      const validVersion = compareVersions.validate(values.value);      
      if(!validVersion){
        SnackBarComponent.getInstance().openSnackbar('invalid app version', 8000, 'error');
        return;
      }
    }
    this.setState({
      processing: true,
    });
    const updatedSetting = this.getSettingFormValues(values);
    this.props.appConfigurationStore.updateConfig(updatedSetting, this.appConfigId)
      .then(() => {
        this.setState({
          processing: false,
        });
        this.props.history.goBack();
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      }).catch((error: any) => {
        console.log(error);
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Add' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography
            className={classes.title}
            variant="h6"
            gutterBottom
          >
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loading
              ? <Spinner />
              : (
                <GeneralFormComponent
                  formTitle={this.settingsFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.settingSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (!this.isNew) {
      console.log(this.isNew);
      this.getAppConfig();
    }
  }

  updateStateWithStaticTextData = () => {
    const formFieldsWithData = this.getFormFields();
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  getAppConfig = () => {
    this.setState({
      loading: true,
    });
    this.props.appConfigurationStore.getConfigById(this.appConfigId)
      .then(() => {
        this.updateStateWithStaticTextData();
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default AddEditSettings;
